<div class="profile-selection-input-container">
  <app-info-box [title]="('steps.profileSelection.title' | translate) + typeAppointment.toLowerCase() + '?'" [description]="'steps.profileSelection.description' | translate">
  </app-info-box>
  @if (inputsForm) {
    <!-- TODO Andrebbero ciclati i campi -->
    <div [formGroup]="inputsForm">
      <div class="input-container">
        <div nz-row [nzGutter]="32">
          <ds-input-text
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="12"
            nzLg="12"
            [control]="inputConfigs['nameInput'].control"
            [label]="'steps.profileSelectionInput.nameLabel' | translate"
            [placeholder]="'steps.profileSelectionInput.namePlaceholder' | translate"
          ></ds-input-text>
          <ds-input-text
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="12"
            nzLg="12"
            [control]="inputConfigs['surnameInput'].control"
            [label]="'steps.profileSelectionInput.surnameLabel' | translate"
            [placeholder]="'steps.profileSelectionInput.surnamePlaceholder' | translate"
          ></ds-input-text>
        </div>
        <div nz-row [nzGutter]="32">
          <ds-input-text
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="12"
            nzLg="12"
            [control]="inputConfigs['taxcodeInput'].control"
            [label]="'steps.profileSelectionInput.taxcodeLabel' | translate"
            [placeholder]="'steps.profileSelectionInput.taxcodePlaceholder' | translate"
          ></ds-input-text>
          <ds-select
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="12"
            nzLg="12"
            [placeholder]="'steps.profileSelectionInput.countryPlaceholder' | translate"
            [label]="'steps.profileSelectionInput.countryLabel' | translate"
            [valuesAndTexts]="countriesData"
            [control]="inputConfigs['countryInput'].control"
          >
          </ds-select>
        </div>
        <div nz-row [nzGutter]="32">
          <ds-select
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="12"
            nzLg="12"
            [placeholder]="'steps.profileSelectionInput.provincePlaceholder' | translate"
            [label]="'steps.profileSelectionInput.provinceLabel' | translate"
            [valuesAndTexts]="districtData"
            [control]="inputConfigs['provinceInput'].control"
          >
          </ds-select>
          <ds-select
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="12"
            nzLg="12"
            [placeholder]="'steps.profileSelectionInput.cityPlaceholder' | translate"
            [label]="'steps.profileSelectionInput.cityLabel' | translate"
            [valuesAndTexts]="citiesData"
            [control]="inputConfigs['cityInput'].control"
          >
          </ds-select>
        </div>
        <div nz-row [nzGutter]="32">
          <ds-input-text
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="12"
            nzLg="12"
            [type]="'number'"
            [control]="inputConfigs['zipcodeInput'].control"
            [label]="'steps.profileSelectionInput.zipcodeLabel' | translate"
            [placeholder]="'steps.profileSelectionInput.zipcodePlaceholder' | translate"
          ></ds-input-text>
          <ds-input-text
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="12"
            nzLg="12"
            [control]="inputConfigs['addressInput'].control"
            [label]="'steps.profileSelectionInput.addressLabel' | translate"
            [placeholder]="'steps.profileSelectionInput.addressPlaceholder' | translate"
          ></ds-input-text>
        </div>
      </div>
      @if (isParentalGradeAble) {
        <app-info-box [title]="'steps.profileSelectionInput.parentData' | translate" [description]="'steps.profileSelectionInput.parentDataDescription' | translate">
        </app-info-box>
        <div class="input-container">
          <div nz-row [nzGutter]="32">
            <ds-select
              nz-col
              nzXs="24"
              nzSm="24"
              nzMd="12"
              nzLg="12"
              [placeholder]="'steps.profileSelectionInput.parentGradePlaceholder' | translate"
              [label]="'steps.profileSelectionInput.parentGradeLabel' | translate"
              [valuesAndTexts]="kinshipData"
              [control]="inputConfigs['parentGradeInput'].control"
            >
            </ds-select>
          </div>
        </div>
      }

      <app-info-box [title]="'steps.profileSelectionInput.doctorData' | translate" [description]="'steps.profileSelectionInput.doctorDataDescription' | translate"> </app-info-box>
      <div class="input-container">
        <div nz-row [nzGutter]="32">
          <ds-input-text
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="12"
            nzLg="12"
            [control]="inputConfigs['nameDoctorInput'].control"
            [label]="'steps.profileSelectionInput.nameLabel' | translate"
            [placeholder]="'steps.profileSelectionInput.namePlaceholder' | translate"
          ></ds-input-text>
          <ds-input-text
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="12"
            nzLg="12"
            [control]="inputConfigs['surnameDoctorInput'].control"
            [label]="'steps.profileSelectionInput.surnameLabel' | translate"
            [placeholder]="'steps.profileSelectionInput.surnamePlaceholder' | translate"
          ></ds-input-text>
        </div>
        <div nz-row [nzGutter]="32">
          <ds-input-text
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="12"
            nzLg="12"
            [control]="inputConfigs['addressDoctorInput'].control"
            [label]="'steps.profileSelectionInput.addressLabel' | translate"
            [placeholder]="'steps.profileSelectionInput.addressPlaceholder' | translate"
          ></ds-input-text>
          <ds-input-text
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="12"
            nzLg="12"
            [control]="inputConfigs['phoneDoctorInput'].control"
            [label]="'steps.profileSelectionInput.phoneLabel' | translate"
            [placeholder]="'steps.profileSelectionInput.phonePlaceholder' | translate"
          ></ds-input-text>
        </div>
      </div>
    </div>
  }
</div>
